<template>    
    <BaseModal
        :id="'static-update'"
        :title="title"
        :size="'lg'"
    >
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>
        <template v-slot:content>
            <form class="col-12 p-0" @submit.prevent="form_submit_update_ext(single_object.id, global_index)">
                <FormDynamic
                    :form_format="form_format"
                    :form_data="single_object"
                    :array_options="array_options"
                    :for_update="true"
                >
                    <template v-slot:more-fields>
                        <div class="formdynamic__item py-0 col-md-6 p-0" style="margin-top: 20px;" v-if="single_object.patient">
                            <div class="formdynamic__item__field">
                                <label for="Vacant bed adjustment:" class="modal-label">Vacant bed adjustment: </label>
                                    <select size="" class="input-field custom-select" v-model="single_object.vacant_bed_adjustment_id">
                                        <option value="">Select an option</option>
                                        <option :value="item.id" v-for="(item, index) in array_options.vacant_bed_adjustment_id" :key="index" v-html="item.name" />
                                </select>
                            </div>
                        </div>
                    </template>
                </FormDynamic>

                <div class="row mb-3 no-gutters" style="margin-top:30px;">
                    <div class="col-12">
                        <ul class="row mb-0 no-gutters nav nav-tabs tabs__custom" id="myTab" role="tablist">
                            <li class="col-md-6 nav-item tabs__custom__item" v-for="(val, i) in tabs" :key="i">
                                <a :class="`nav-link ${i === 0 ? 'active' : '' } tabs__custom__link`" data-toggle="tab" :href="val.href_child_tab_update">
                                    {{ val.name }}
                                </a>
                            </li>
                        </ul>

                        <div class="tab-content mt-3" style="margin-top:30px;">

                            <div class="tab-pane fade show active" id="daily-update" role="tabpanel" aria-labelledby="instant-tab">
                                <div class="tab-content">
                                    <div class="tab-pane fade active show" style="top:0px;">
                                        <div class="row">
                                            <div class="col-lg-12">
                                                <div class="w-100 table-responsive overflow-y--1">
                                                    <table class="table">
                                                        <thead style="background-color: #f1f1f1;">
                                                            <tr>
                                                                <th v-for="(item, i) in task_table_headers" :key="i" scope="col" v-html="item.name"/>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="(task, i) in tasks" :key="i">
                                                                <td>
                                                                    <span class="custom-control custom-checkbox">
                                                                        <input :id="`update_checkbox${task.id}`" type="checkbox" class="custom-control-input" name="task_update" v-model="task.checked"/>
                                                                        <label :for="`update_checkbox${task.id}`" class="custom-control-label ml-2"/>
                                                                    </span>
                                                                </td>
                                                                <td v-html="task.name"/>
                                                                <td v-html="task.description"/>
                                                                <td>
                                                                    <span>
                                                                        <input :id="`singleDaily_update_frequency_policing${i}`" type="number" class="form-control" v-model="task.frequency" :placeholder="'Daily frequency'"/>
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <span>
                                                                        <input :id="`singleDaily_update_order${i}`" type="number" class="form-control" v-model="task.order" :placeholder="'Order'"/>
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="tab-pane fade" id="policing-update" role="tabpanel" aria-labelledby="instant-tab">
                                <div class="tab-content">
                                    <div class="tab-pane fade active show" >
                                        <div class="row">
                                            <div class="col-lg-12">
                                                <div class="w-100 table-responsive overflow-y--1">
                                                    <table class="table">
                                                        <thead style="background-color: #f1f1f1;">
                                                            <tr>
                                                                <th v-for="(item, i) in task_table_headers" :key="i" scope="col" v-html="item.name"/>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="(task, i) in policings" :key="i">
                                                                <td>
                                                                    <span class="custom-control custom-checkbox">
                                                                        <input :id="`up_checkboxPolicing${i}`" type="checkbox" class="custom-control-input" name="policing" v-model="task.checked" :checked="task.checked"/>
                                                                        <label :for="`up_checkboxPolicing${i}`" class="custom-control-label ml-2"/>
                                                                    </span>
                                                                </td>
                                                                <td v-html="task.name"/>
                                                                <td v-html="task.description"/>
                                                                <td>
                                                                    <span>
                                                                        <input :id="`update_policing_frequency_policing${i}`" type="number" class="form-control" v-model="task.frequency" :placeholder="'Policing frequency'"/>
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <span>
                                                                        <input :id="`up_order_policing${i}`" type="number" class="form-control" v-model="task.order" :placeholder="'Order'"/>
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <CentralButtons /> 
            </form>
        </template>
    </BaseModal>
</template>

<script>

import FormResources  from './form_resources'
import Resources      from './resources'
import FormDynamic    from '@/components/FormDynamic.vue'
import Breadcrumb     from '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal      from '@/components/BaseModal'
import CentralButtons from '@/components/CentralButtons'

export default {

    name:   'UpdateModal',

    props: [
        'title',
        'content_header',
        'rest_api',
        'notifications',
        'notyf',
        'axios',
        'single_object',
        'global_index',
        'array_options',
        'tasks',
        'policings',
        'breadcrumb',
    ],

    components:{
        FormDynamic,
        Breadcrumb,
        BaseModal,
        CentralButtons,
    },

    data(){
        return{
            form_format: FormResources.form_format,
            task_table_headers: Resources.task_table_headers,
            tabs: Resources.tabs,
        }
    },

    watch: {

        "single_object.unit"(val)
        {
            if(val < 1 || val > 6)
            {
                this.single_object.unit = 1
            }
        },
    },
    
    methods:{

        async form_submit_update_ext(id, global_index)
        {
            this.single_object.daily_tasks      = this.tasks.filter(item => item.checked)
            this.single_object.policing_tasks   = this.policings.filter(item => item.checked)

            if(this.single_object.unit < 1 || this.single_object.unit > 6)
            {
                this.notyf.error("Unit can't be lower than 1 nor higher than 6 either")
                return false
            }

            let validateTasks = (tasks) => 
            {
                return tasks.some(task => task.frequency === '' || task.order === '');
            };

            let frequency_daily_task_validation     = validateTasks(this.single_object.daily_tasks);
            let frequency_policing_task_validation  = validateTasks(this.single_object.policing_tasks);

            if (frequency_daily_task_validation || frequency_policing_task_validation) 
            {
                this.notyf.error('Frequency cannot be empty');
            }

            if (validateTasks(this.single_object.daily_tasks.concat(this.single_object.policing_tasks))) 
            {
                this.notyf.error('Order cannot be empty');
            }

            if (frequency_daily_task_validation || frequency_policing_task_validation) 
            {
                return false;
            }

            await this.form_submit_update(id, global_index)
        },
        
    },

    mounted(){

    }
    
}
</script>